import { useCommonReducer } from '@components/Shared/State/hooks';
const useProductPage = (variantId, quantity, extraProducts, product, isCart, inject) => useCommonReducer(isCart ? `product_page_form_${variantId}` : `product_page_form`, {
    variantId,
    extraProducts,
    quantity,
    product: product,
    variants: [],
}, inject);
export default useProductPage;
